import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import Header from '@/components/layout/Header';
import { useI18n } from '@/hooks/useI18n';

const ImprintPage = () => {
    const navigate = useNavigate();
    const { t } = useI18n();

    return (
        <>
            <Header title={t('pages.imprint.title')} onBack={() => navigate('/')} />
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('pages.imprint.title')}
                </Typography>
                <Typography variant="body1" paragraph>
                    {t('pages.imprint.legalNotice')}
                </Typography>
                
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body1">
                        {t('pages.imprint.companyName')}<br />
                        {t('pages.imprint.address')}<br />
                        {t('pages.imprint.cityPostal')}
                    </Typography>
                </Box>
                
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('pages.imprint.contact')}
                </Typography>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body1">
                        {t('pages.imprint.phone')}<br />
                        {t('pages.imprint.email')}
                    </Typography>
                </Box>
                
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {t('pages.imprint.responsibleContent')}
                </Typography>
                <Typography variant="body1">
                    {t('pages.imprint.companyName')}<br />
                    {t('pages.imprint.addressAs')}
                </Typography>
            </Container>
        </>
    );
};

export default ImprintPage;
